import React from "react";
export const EqualContentsRow = ({ fontSizeOverride, children, customStyles }) => {
  let style = {};
  fontSizeOverride && (style.fontSize = fontSizeOverride);
  return (
    <div className={"report-equal-contents-row"} style={{ ...style, ...customStyles }}>
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/EqualContentsRow.jsx